import { URL_VISITED, URL_WITHOUT_DMV } from '../config'

export function notLoadDMV() {
  if (URL_WITHOUT_DMV.includes(URL_VISITED)) {
    window.DFI_client.dmv = 'false'
    sessionStorage.wm_env = 'd'
  }
}
